module.exports = __webpack_public_path__ + "img/technology5.a6b2cd09.png";